module.exports = __webpack_public_path__ + "img/1.2d39f70e.jpg";